export default __webpack_public_path__ + "static/media/app-bar-logo.9cc9cd8c.svg";